export default __webpack_public_path__ + "static/media/desktopDesign.34c3e55d.webp";